
const restRoom = {
  namespaced: true,
  state: {
    params: {id:''},
    searchInfo: {},
    travelerList: [],
    roomList:[],
  },
  getters: {//getters属性理解为所有组件的computed属性, 也就是计算属性 
    searchInfo: (state) => {
      return state.searchInfo || {}
    },
    params: (state) => {
      return state.params || {}
    },
    travelerList: (state) => {
      return state.travelerList || []
    },
    roomList: (state) => {
      return state.roomList || []
    }
  },
  mutations: { //mutaions理解为store中的methods
    searchInfo (state, payload) {
      state.searchInfo = payload
    },
    params (state, payload) {
      state.params = payload
    },
    travelerList (state, payload) {
      state.travelerList = payload
    },
    setRoomList (state, payload) {
      state.roomList = payload
    },
    CLEAR_ALL (state, payload) { 
      state.carSearchInfo = {}
      state.travelerList = []
      state.roomList =[]
    }
  },
  actions: { //添加actions actions中可以包含异步操作
    // minusPriceAsync( context, payload ) {
    // setTimeout( () => {
    //     context.commit( 'minusPrice', payload ); //context提交
    // }, 2000)
    // }
  }
}
export default restRoom